import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sortBy, toArray } from 'lodash';

import { DiscountListComponent } from '../../discount/DiscountListComponent';

import './DiscountsListComponent.scss';

class DiscountsListComponent extends React.Component {
    filterDiscounts = (discounts, isOffline) => {
        return isOffline
            ? discounts.filter(d => d.offlineActive)
            : discounts.filter(d => d.onlineActive);
    };

    render() {
        const { discounts, i18n, isOffline, isQwertys } = this.props;
        const discountsList = this.filterDiscounts(discounts, isOffline);

        return (
            <section className="fm-remises">
                {discountsList.length > 0 && (
                    <div>
                        <h3>
                            {isQwertys
                                ? i18n.DETAIL_OFFER_TITLE
                                : `${i18n.DETAIL_CASHBACK_TITLE} ${
                                      isOffline ? i18n.OFFLINE : i18n.ONLINE
                                  }`}
                        </h3>
                        <DiscountListComponent
                            discounts={discountsList}
                            showArrow
                            isQwertys={isQwertys}
                        />
                        <hr />
                    </div>
                )}
            </section>
        );
    }
}

DiscountsListComponent.propTypes = {
    partnerId: PropTypes.string.isRequired,
    isOffline: PropTypes.bool,
    isQwertys: PropTypes.bool
};

const mapStoreToProps = (state, ownProps) => ({
    i18n: state.i18n.page.MERCHANTCARD,
    discounts: sortBy(toArray(state.discount.discounts[ownProps.partnerId]), ['order'])
});

export default connect(mapStoreToProps)(DiscountsListComponent);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/DiscountsListComponent.js